import StatsAndMetrics from './StatsAndMetrics.vue'

export default StatsAndMetrics
